import styled, { css } from 'styled-components/macro'
import { RiLogoutBoxRLine } from 'react-icons/ri'
import { FiSettings } from 'react-icons/fi'
import { BsBell } from 'react-icons/bs'

export const TopBarTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #ffffff;
  margin-right: 16px;
`

export const CompanyTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  margin-right: 16px;
  margin-left: 16px;
  line-height: 24px;
`

export const Wrapper = styled.div`
  background: #06512f;
  min-height: var(--footer-height);
  height: var(--footer-height);
  color: white;
  display: flex;
  align-items: center;
  padding: 0 60px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 16px;
    justify-content: center;
  }
`

// Identical to NotificationButton.styles.ts SharedButton
const iconStyle = css`
  cursor: pointer;
  color: white;
  font-size: 28px;
  height: 45px;
  width: 45px;
  padding: 10px;
  flex-shrink: 0;
  &:hover {
    background: rgb(44, 107, 78);
  }
`
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 10px;
  gap: 10px;
`

export const SettingsIcon = styled(FiSettings)`
  ${iconStyle}
`

export const LogoutIcon = styled(RiLogoutBoxRLine)`
  ${iconStyle}
`

export const NotificationIcon = styled(BsBell)`
  color: #ffffff;
  cursor: pointer;
  font-size: 20px;
  margin-right: 16px;
  transition: all 0.05s ease-in-out;

  &:hover {
    color: #f2f4f7;
  }
`

export const LogoImg = styled.img`
  margin-right: 40px;
`
